export const numberToWords = (num) => {
  const units = [
    "",
    "One",
    "Two",
    "Three",
    "Four",
    "Five",
    "Six",
    "Seven",
    "Eight",
    "Nine",
  ];
  const teens = [
    "Ten",
    "Eleven",
    "Twelve",
    "Thirteen",
    "Fourteen",
    "Fifteen",
    "Sixteen",
    "Seventeen",
    "Eighteen",
    "Nineteen",
  ];
  const tens = [
    "",
    "Ten",
    "Twenty",
    "Thirty",
    "Forty",
    "Fifty",
    "Sixty",
    "Seventy",
    "Eighty",
    "Ninety",
  ];

  if (num === 0) return "Zero";

  const convertChunk = (n) => {
    if (n === 0) return "";
    let words = "";
    if (Math.floor(n / 100) > 0) {
      words += units[Math.floor(n / 100)] + " Hundred ";
      n %= 100;
    }
    if (n >= 20) {
      words += tens[Math.floor(n / 10)] + " ";
      n %= 10;
    } else if (n >= 10) {
      words += teens[n - 10] + " ";
      n = 0;
    }
    if (n > 0 && n < 10) {
      words += units[n] + " ";
    }
    return words;
  };

  let words = "";
  if (Math.floor(num / 10000000) > 0) {
    words += convertChunk(Math.floor(num / 10000000)) + "Crore ";
    num %= 10000000;
  }
  if (Math.floor(num / 100000) > 0) {
    words += convertChunk(Math.floor(num / 100000)) + "Lakh ";
    num %= 100000;
  }
  if (Math.floor(num / 1000) > 0) {
    words += convertChunk(Math.floor(num / 1000)) + "Thousand ";
    num %= 1000;
  }
  if (Math.floor(num / 100) > 0) {
    words += convertChunk(Math.floor(num / 100)) + "Hundred ";
    num %= 100;
  }
  words += convertChunk(num);

  return words.trim() + " Only";
};
